/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Commits_TextInputs */

const en_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This project does not have any commits (yet). You can still create a Share for your team, but you will need to sync any Event Groups before they become available.`)
};

const fr_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce projet n’a encore aucun commit. Vous pouvez tout de même créer un partage pour votre équipe, mais vous devrez synchroniser les groupes d’événements avant qu’ils ne deviennent disponibles.`)
};

const de_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Projekt enthält (noch) keine Commits. Sie können trotzdem eine Freigabe für Ihr Team erstellen, müssen aber alle Ereignisgruppen synchronisieren, bevor diese verfügbar werden.`)
};

const it_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo progetto non ha ancora alcun commit. Puoi comunque creare una condivisione per il tuo team, ma dovrai sincronizzare tutti i gruppi di eventi prima che diventino disponibili.`)
};

const ru_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этом проекте пока нет никаких изменений (коммитов). Вы всё ещё можете создать общий доступ для своей команды, но вам потребуется синхронизировать все группы событий, прежде чем они станут доступны.`)
};

const es_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este proyecto no tiene confirmaciones (aún). Puedes crear un recurso compartido para tu equipo, pero deberás sincronizar los grupos de eventos antes de que estén disponibles.`)
};

const zh_cn2_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该项目目前还没有任何提交。您仍然可以为您的团队创建共享，但需要先同步所有事件组，共享才能生效。`)
};

const ja_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプロジェクトにはまだコミットがありません。チーム用の共有を作成することは可能ですが、イベントグループを同期してからでないと利用できません。`)
};

const hi_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस प्रोजेक्ट में अभी तक कोई कमिट नहीं हुआ है। आप अपनी टीम के लिए शेयर बना सकते हैं, लेकिन इसके उपलब्ध होने से पहले आपको सभी इवेंट ग्रुप्स को सिंक करना होगा।`)
};

const pt_pt2_team_share_no_commits_text = /** @type {(inputs: Team_Share_No_Commits_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este projeto ainda não possui nenhuma atualização (ainda). Você ainda pode criar um compartilhamento para sua equipe, mas precisará sincronizar todos os Grupos de Eventos antes que eles fiquem disponíveis.`)
};

/**
* | output |
* | --- |
* | "This project does not have any commits (yet). You can still create a Share for your team, but you will need to sync any Event Groups before they become avail..." |
*
* @param {Team_Share_No_Commits_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_commits_text = /** @type {((inputs?: Team_Share_No_Commits_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Commits_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_no_commits_text(inputs)
	if (locale === "de") return de_team_share_no_commits_text(inputs)
	if (locale === "it") return it_team_share_no_commits_text(inputs)
	if (locale === "ru") return ru_team_share_no_commits_text(inputs)
	if (locale === "es") return es_team_share_no_commits_text(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_no_commits_text(inputs)
	if (locale === "ja") return ja_team_share_no_commits_text(inputs)
	if (locale === "hi") return hi_team_share_no_commits_text(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_no_commits_text(inputs)
	return en_team_share_no_commits_text(inputs)
});